export default __webpack_public_path__ + "static/media/marketplace-tests.35bcc313.png";